// extracted by mini-css-extract-plugin
export default {"guestBadge":"UserLink_guestBadge__MgeYV"};